export default "__VITE_ASSET__c81883b1__"